/**
 * @name throttle
 *
 * @description Throttles a function by a given time in milliseconds
 *
 * @example
 * import { throttle } from '@workbench/core';
 *
 * const throttledFn = throttle(fn, 300);
 */
export const throttle = (fn: (...args: Array<unknown>) => unknown, milliseconds: number, immediate = false): (() => void) => {
  let timeout = null;
  let initialCall = true;

  return function () {
    const callNow = immediate && initialCall;
    const next = () => {
      // eslint-disable-next-line prefer-rest-params
      fn.apply(this, arguments);
      timeout = null;
    };

    if (callNow) {
      initialCall = false;
      next();
    }

    if (!timeout) {
      timeout = setTimeout(next, milliseconds);
    }
  };
};
